.banner,
.preferences {
  color: var(--cream, #fff3d6);
  background: var(--ink, #08111f);
  border: 2px solid var(--teal, #4dd2c8);
  font-family: "Press Start 2P", monospace;
  box-shadow: 5px 5px 0 var(--pink, #f06b8d);
}

.banner {
  box-sizing: border-box;
  position: fixed;
  z-index: 10000;
  right: 1rem;
  bottom: 1rem;
  left: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  width: min(760px, calc(100% - 2rem));
  max-height: calc(100dvh - 2rem);
  margin-inline: auto;
  padding: 1rem;
  overflow: auto;
  overflow-wrap: anywhere;
  white-space: normal;
}

.settingsBackdrop {
  position: fixed;
  z-index: 9999;
  inset: 0;
  display: grid;
  place-items: center;
  box-sizing: border-box;
  padding: 1rem;
  background: rgba(4, 10, 20, 0.78);
}

.banner.settingsPanel {
  position: relative;
  inset: auto;
  width: min(720px, 100%);
  max-height: 100%;
  margin-inline: 0;
}

.copy {
  display: grid;
  flex: 1 1 0;
  gap: 0.55rem;
  min-width: 0;
  white-space: normal;
}

.copy strong {
  color: var(--teal, #4dd2c8);
  font-size: 0.67rem;
  letter-spacing: 0.06em;
  white-space: normal;
}

.copy span {
  font-family: "VT323", monospace;
  font-size: 1.2rem;
  line-height: 1.15;
  white-space: normal;
}

.copy a {
  color: var(--cream, #fff3d6);
}

.actions {
  display: flex;
  flex: 0 0 auto;
  gap: 0.65rem;
}

.actions button,
.preferences {
  min-height: 44px;
  padding: 0.7rem 0.8rem;
  cursor: pointer;
  font-size: 0.58rem;
  line-height: 1.35;
}

.allow {
  color: var(--ink, #08111f);
  background: var(--teal, #4dd2c8);
  border: 2px solid var(--teal, #4dd2c8);
}

.decline {
  color: var(--cream, #fff3d6);
  background: transparent;
  border: 2px solid rgba(255, 243, 214, 0.56);
}

.preferences {
  position: fixed;
  z-index: 9999;
  right: 0.75rem;
  bottom: 0.75rem;
  opacity: 0.78;
}

.preferences.inlinePreferences {
  position: static;
  z-index: auto;
  min-height: 24px;
  margin-block: -8px;
  padding: 0;
  color: var(--teal, #4dd2c8);
  background: transparent;
  border: 0;
  box-shadow: none;
  font: inherit;
  letter-spacing: inherit;
  line-height: inherit;
  opacity: 1;
}

.preferences.inlinePreferences:hover {
  color: var(--pink, #f06b8d);
}

.actions button:focus-visible,
.preferences:focus-visible,
.copy a:focus-visible {
  outline: 3px solid var(--gold, #f7b955);
  outline-offset: 3px;
}

@media (max-width: 680px) {
  .banner {
    align-items: stretch;
    flex-direction: column;
    gap: 0.85rem;
  }

  .actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
}

@media print {
  .banner,
  .preferences {
    display: none;
  }
}
